<div class="container">
<div class="row justify-content-center">
    <div class="col-12 col-md-8 col-lg-6 text-center">
    <ClientLogo class="my-4" />

    <h5 class="text-s text-center mb-4"><strong>Onboarding on Behalf of Someone</strong></h5>

    <div class="row">
        <div class="col-12 text-start">
        <label class="form-label fw-bold">Full Name <span class="text-danger">*</span></label>
        <input 
            type="text" 
            class="form-control rounded-small p-3 shadow-sm" 
            v-model="fullName" 
            required="True"
            placeholder="Enter full name"
        >
        <small class="text-danger fw-bold d-block mt-1" v-if="errors.fullName">
            {{ errors.fullName }}
        </small>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-12 text-start">
        <label class="form-label fw-bold">Description</label>
        <textarea 
            class="form-control rounded-small p-3 shadow-sm" 
            v-model="description" 
            rows="3"
            placeholder="Enter any additional information (optional)"
        ></textarea>
        </div>
    </div>

    <div class="row mt-4">
        <div class="col-6 text-start">
        <button class="btn btn-light btn-sm shadow rounded-small fw-bold" @click="goBack">
            Cancel
        </button>
        </div>
        <div class="col-6 text-end">
        <button 
            class="btn bg-success text-white btn-sm shadow rounded-small fw-bold" 
            @click="submit_form" 
            :disabled="isSubmitting"
        >
            <span v-if="isSubmitting">Processing...</span>
            <span v-else>Continue</span>
        </button>
        </div>
    </div>
    </div>
</div>
</div>